import React from 'react';

function escapeRegExp(string) {
	return String(string).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function hasKeywordHighlight(text, keyword) {
	const str = text == null ? '' : String(text);
	const kw = keyword != null ? String(keyword).trim() : '';
	if (!kw) return false;
	try {
		return new RegExp(escapeRegExp(kw), 'i').test(str);
	} catch {
		return false;
	}
}

const Highlighter = ({ text, keyword }) => {
	const str = text == null ? '' : String(text);
	const kw = keyword != null ? String(keyword).trim() : '';

	// Empty pattern: `new RegExp('', 'gi')` matches between every character → empty <mark> spam.
	if (!kw) {
		return <span>{str}</span>;
	}

	let re;
	try {
		re = new RegExp(escapeRegExp(kw), 'gi');
	} catch {
		return <span>{str}</span>;
	}

	const nodes = [];
	let last = 0;
	let match;
	while ((match = re.exec(str)) !== null) {
		if (match.index > last) {
			nodes.push(str.slice(last, match.index));
		}
		nodes.push(
			<mark key={`h-${match.index}-${nodes.length}`} className="bg-primary-100 text-primary">
				{match[0]}
			</mark>
		);
		last = re.lastIndex;
		// Avoid infinite loop if pattern ever matches empty string
		if (match[0].length === 0) {
			re.lastIndex++;
			if (re.lastIndex > str.length) break;
		}
	}
	if (last < str.length) {
		nodes.push(str.slice(last));
	}

	return <span data-keyword={kw}>{nodes}</span>;
};

export default Highlighter;
